export const EXPORT_OPTIONS = [
	{
		label: 'Export as image',
		value: 'png',
	},
];
